<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		name: 'App'
	}
</script>

<style lang="scss">
	@import './styles/base';
	@import './styles/commom';
	@import './styles/element-ui';
</style>




// WEBPACK FOOTER //
// src/App.vue